import { useQuery } from "@tanstack/react-query";
import { fetchKPIIndicators, KPIIndicatorsResponse } from "PFCore/services/kpi";
import { QueryOptions } from "PFCore/types";

import { KPIKeys } from "./query_keys";

export const useKPIs = <TData = KPIIndicatorsResponse>(
  options: QueryOptions<KPIIndicatorsResponse, any, TData> = {}
) =>
  useQuery<KPIIndicatorsResponse, any, TData>({
    queryKey: KPIKeys.KPIIndicators(),
    queryFn: fetchKPIIndicators,
    retry: false,
    ...options
  });
